import { render, staticRenderFns } from "./CsvImporter.vue?vue&type=template&id=388f555a"
import script from "./CsvImporter.vue?vue&type=script&lang=js"
export * from "./CsvImporter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports